import { type DateString, formatDateNumberShort } from '#src/dates.ts'

export function medicationsPdfTitle(
  participantName: string,
  on: DateString
): string {
  return `${participantName} - Medications - ${formatDateNumberShort(on)}`
}

export function medicationsPdfFilename(
  participantName: string,
  on: DateString
): string {
  const safe = medicationsPdfTitle(participantName, on)
    .replace(/[\\/]/g, '-')
    .replace(/"/g, '')
  return `${safe}.pdf`
}
